import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function AssetDetails() {
  const navigate = useNavigate();
  const { id } = useParams();
  
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <button onClick={() => navigate('/assets')} className="mb-4 text-blue-600 hover:underline">
          ← Back to Assets
        </button>
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Asset Details (ID: {id})</h1>
        <div className="bg-white rounded-lg shadow p-6">
          <p className="text-gray-600">Asset details coming soon...</p>
        </div>
      </div>
    </div>
  );
}
